/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BeamAnalysisCorrectionSettingsDto } from './BeamAnalysisCorrectionSettingsDto';
import {
    instanceOfBeamAnalysisCorrectionSettingsDto,
    BeamAnalysisCorrectionSettingsDtoFromJSON,
    BeamAnalysisCorrectionSettingsDtoFromJSONTyped,
    BeamAnalysisCorrectionSettingsDtoToJSON,
} from './BeamAnalysisCorrectionSettingsDto';

/**
 * @type BeamAnalysisWorkItemDtoCorrectionSettings
 * 
 * @export
 */
export type BeamAnalysisWorkItemDtoCorrectionSettings = BeamAnalysisCorrectionSettingsDto;


export function BeamAnalysisWorkItemDtoCorrectionSettingsFromJSON(json: any): BeamAnalysisWorkItemDtoCorrectionSettings {
    return BeamAnalysisWorkItemDtoCorrectionSettingsFromJSONTyped(json, false);
}

export function BeamAnalysisWorkItemDtoCorrectionSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamAnalysisWorkItemDtoCorrectionSettings {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...BeamAnalysisCorrectionSettingsDtoFromJSONTyped(json, true) };
    return  BeamAnalysisCorrectionSettingsDtoFromJSONTyped(json, true);
}

export function BeamAnalysisWorkItemDtoCorrectionSettingsToJSON(value?: BeamAnalysisWorkItemDtoCorrectionSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfBeamAnalysisCorrectionSettingsDto(value)) {
        return BeamAnalysisCorrectionSettingsDtoToJSON(value as BeamAnalysisCorrectionSettingsDto);
    }

    return {};
}

/**
 * Check if a given object implements the BeamAnalysisWorkItemDtoCorrectionSettings interface.
 */
export function instanceOfBeamAnalysisWorkItemDtoCorrectionSettings(value: any): value is BeamAnalysisWorkItemDtoCorrectionSettings {
    if (instanceOfBeamAnalysisCorrectionSettingsDto(value)) return true;
    return false;
}

